export default __webpack_public_path__ + "static/media/promotion_tel.82a0479f.svg";